import React from "react";
import {lighten, makeStyles} from "@material-ui/core/styles";
import FuseAnimate from "../fuse-animate/fuse-animate";
import {Card, Paper} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import format from '../../utils/format';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import externalLink from "../../utils/external-link";
import {InvoiceStatus} from "../../components";
import clsx from "clsx";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
    },
    accordionSummary: {
        '&:hover, &:focus, &:active': {
            // backgroundColor:  grey[200],
            backgroundColor: lighten(theme.palette.primary.light, 0.85)
        },
    },
    expanded: {
        // backgroundColor: grey[200],
        backgroundColor: lighten(theme.palette.primary.light, 0.85)
    },
    accordionDetails: {
        // backgroundColor: grey[50],
        backgroundColor: lighten(theme.palette.primary.light, 0.95)
    },
    linkButton: {
        marginTop: 24,
    },
    dataLabel: {
        minWidth: 75,
        fontWeight: 500,
    },
    panel: {
        minHeight: 48,
        display: 'flex',
        alignItems: 'center',
        borderBottomWidth: 1,
    },
}));


const RecentPurchases = ({ purchases, animation, delay }) => {
    const classes = useStyles();
    const isWide = useMediaQuery(theme => theme.breakpoints.up('md'));

    return (
        <FuseAnimate animation={animation} delay={delay}>
            <Card id="payments-card" className={classes.root}>
                <Typography variant="h6" color="secondary">Recent Purchases</Typography>

                <div className="mt-4">

                    {/* Column Headers */}
                    { isWide ? <PanelHeader/> : <AccordionPanelHeader/> }

                    {/* No items */}
                    { purchases.length === 0 ? <div className="p-4">No recent purchases.</div> : null }

                    {/* Table */}
                    { isWide ? <Panel purchases={purchases} /> : <AccordionPanel purchases={purchases}/>}

                </div>

                <Button variant="outlined"
                        color="primary"
                        size="large"
                        component={Link}
                        to={{pathname: "/account", state: {scrollTo: 'purchases-panel'}}}
                        className={classes.linkButton}
                >View Account</Button>

            </Card>
        </FuseAnimate>
    )
}


const AccordionPanelHeader = () => {
    return (
        <div className="flex flex-grow border-b-2">
            <div className="flex flex-grow uppercase pb-1 ml-4 mr-12">
                <div className="w-5/12 md:w-1/4">Date</div>
                <div className="hidden md:flex md:w-1/4">Reference</div>
                <div className="w-4/12 md:w-1/4">Amount</div>
                <div className="w-3/12 md:flex md:w-1/4">Status</div>
            </div>
        </div>
    )
}

const AccordionPanel = ({purchases}) => {
    const classes = useStyles();

    return purchases.map((purchase) => (
        <Accordion key={purchase.id}>
            <AccordionSummary
                classes={{root: classes.accordionSummary, expanded: classes.expanded}}
                expandIcon={<ExpandMoreIcon/>}
            >
                <div className="flex flex-row flex-grow font-light items-center">
                    <div className="w-5/12 md:w-1/4">{format('date-only', purchase.date)}</div>
                    <div className="hidden md:flex md:w-1/4">{purchase.reference}</div>
                    <div className="w-4/12 md:w-1/4 font-bold">${(purchase.amount/100).toFixed(2)}</div>
                    <div className="w-3/12 pl-1 md:flex md:w-1/4">
                        <InvoiceStatus status={purchase.status} />
                    </div>
                </div>
            </AccordionSummary>

            <AccordionDetails
                className={classes.accordionDetails}
            >
                <div className="flex flex-col flex-grow font-light">
                    <div className="flex flex-row p-1 md:w-1/2 pb-3">
                        <div className={clsx(classes.dataLabel, 'hidden', 'sm:block')}>Item</div>
                        <div className="font-medium sm:font-normal">{purchase.description}</div>
                    </div>
                    <div className="flex flex-row p-1 md:w-1/2 pb-3">
                        <div className={classes.dataLabel}>Reference</div>
                        <div className="">{purchase.reference}</div>
                    </div>

                    <Button variant="outlined"
                            color="primary"
                            size="large"
                            onClick={(e) => externalLink(e, purchase.receiptUrl)}
                    >View Receipt</Button>

                </div>
            </AccordionDetails>
        </Accordion>
    ))
}

const PanelHeader = () => {
    return (
        <div className="flex flex-grow border-b-2">
            <div className="flex flex-grow uppercase pb-1 ml-4 mr-20"       /*{classes.headerRow}*/>
                <div className="w-1/3 md:w-1/4">Date</div>
                <div className="hidden md:flex md:w-1/4">Reference</div>
                <div className="w-1/3 md:w-1/4">Amount</div>
                <div className="w-1/3 md:flex md:w-1/4">Status</div>
            </div>
        </div>
    )
}

const Panel = ({purchases}) => {
    const classes = useStyles();

    return (
        <Paper>
            { purchases.map((purchase) => (
                <div className={classes.panel} key={purchase.id}>
                    <div className="flex flex-row flex-grow font-light items-center pl-4 pr-4">
                        <div className="w-1/3 md:w-1/4">{format('date-only', purchase.date)}</div>
                        <div className="hidden md:flex md:w-1/4">{purchase.reference}</div>
                        <div className="w-1/3 md:w-1/4 font-bold">${(purchase.amount/100).toFixed(2)}</div>
                        <div className="w-1/3 md:flex md:w-1/4">
                            <InvoiceStatus status={purchase.status} />
                        </div>
                        <Button variant="outlined"
                                color="primary"
                                size="small"
                                onClick={(e) => externalLink(e, purchase.receiptUrl)}
                        >View</Button>
                    </div>
                </div>
            ))}
        </Paper>
    )
}

export default RecentPurchases;